import { TRootState } from "Redux/Reducers";

export const getEvent = (id: string) => (state: TRootState) => state.event.entries[id];
